module.exports = __webpack_public_path__ + "img/schools.9b51a4b5.png";